import LicenseTable from "@/v2-backoffice-client/license/LicenseTable"
import { useLicenseQuery } from "@/v2-backoffice-client/license/license.query"
import { useLicenseAddOnsQuery } from "@/v2-backoffice-client/license/addOns/license.addOns.query"
import { useLicenseSeatHoldersQuery } from "@/v2-backoffice-client/license/seats/license.seats.holders.query"

export type CustomerLicenseProps = {
  customerId: number
  customerName?: string
}

// The customer panel's Licenses tab: this customer's licenses and trials with
// the same actions as the board, plus a grant button scoped to the customer.
function CustomerLicense(props: CustomerLicenseProps) {
  const { customerId, customerName } = props

  const { data, loading, error, refetch } = useLicenseQuery({
    variables: { customerId },
  })

  // Same query the Add-ons section under this table uses (same variables),
  // so the two share one cache entry and an add-on change refreshes both.
  const { data: addOnsData } = useLicenseAddOnsQuery({
    variables: { customerId },
  })

  // Who holds a seat on the seated licenses, shown by name under each row
  // (the same read the Users and Feature access tabs group per person).
  const { data: seatHoldersData } = useLicenseSeatHoldersQuery({
    variables: { customerId },
  })

  const licenses = data?.getLicenses ?? []

  return (
    <LicenseTable
      licenses={licenses}
      isLoading={loading}
      error={error}
      customerId={customerId}
      customerName={customerName}
      customerAddOns={addOnsData?.getCustomerAddOns}
      licenseSeatHolders={seatHoldersData?.getLicenseSeatHolders}
      onRefresh={refetch}
    />
  )
}

export default CustomerLicense
